export default __webpack_public_path__ + "static/media/l1_danek_skvrnity-min.d0745e8f.jpg";